import { render, staticRenderFns } from "./Reviewrating.vue?vue&type=template&id=0bbdde33&scoped=true"
import script from "./Reviewrating.vue?vue&type=script&lang=js"
export * from "./Reviewrating.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Reviewrating.vue?vue&type=style&index=0&id=0bbdde33&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./Reviewrating.vue?vue&type=style&index=1&id=0bbdde33&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0bbdde33",
  "e7d0f4b2"
  
)

export default component.exports